import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from "classnames";
import Icon from "../../../Icon";
import Button from "../../../Button";
import style from "./style.module.scss";
export default function SelectPill(props) {
    const { option, removable = false, viewOnly = false, onEdit, onRemove } = props;
    const removeOption = (event) => {
        if (onRemove) {
            onRemove();
        }
        event.stopPropagation();
    };
    function editOption(event) {
        if (onEdit) {
            onEdit();
        }
        event.stopPropagation();
    }
    if (viewOnly) {
        return _jsx("div", { className: style["select-pill--view-only"], children: option.label });
    }
    else {
        return (_jsxs("div", { className: style["select-pill"], children: [_jsxs(Button, { variation: "none", className: classNames(style["select-pill__main"], {
                        [style["select-pill__main--delete"]]: removable,
                    }), onClick: editOption, children: [option.label, removable ? null : (_jsx("span", { className: style["select-pill__main__edit"], children: _jsx(Icon, { name: "caret--thin--down" }) }))] }), removable ? (_jsxs(Button, { variation: "none", className: style["select-pill__delete"], onClick: removeOption, children: [_jsx(Icon, { name: "xmark--thin" }), _jsx("span", { className: "visually-hidden", children: "Remove option" })] })) : null] }));
    }
}
